import { API } from "aws-amplify";
import {makeType,actionCreator} from '../../Utils/generateActionCreator';

const actionType = makeType('POLICY');

export const ADD_CLIENT = actionType('ADD_CLIENT')
export const API_CLIENTE = actionType('API_CLIENTE')
export const RESET = actionType('RESET')
export const UPDATE_CLIENT = actionType('UPDATE_CLIENT')
export const ADD_BENEFICIARY = actionType('ADD_BENEFICIARY');
export const REMOVE_BENEFICIARY = actionType('REMOVE_BENEFICIARY');
export const ADD_WORK_DATA = actionType('ADD_WORK_DATA')
export const UPDATE_WORK_DATA = actionType('UPDATE_WORK_DATA')
export const ADD_HEALTH_STATEMENT = actionType('ADD_HEALTH_STATEMENT')
export const ADD_ANSWERS = actionType('ADD_ANSWERS')
export const OPEN_MODAL = actionType('OPEN_MODAL'); 
export const MODAL_STEPS = actionType('MODAL_STEPS');
export const MODAL_ERRORS = actionType('MODAL_ERRORS');
export const MODAL_ASIDE = actionType('MODAL_ASIDE');
export const ERROR_TEXT = actionType('ERROR_TEXT');
export const ALERT = actionType('ALERT'); 
export const STATEALERT = actionType('STATEALERT');
export const STEP_POSITION = actionType('STEP_POSITION');
export const DATA_MODAL = actionType('DATA_MODAL');
export const GENERATE_QUOTE = actionType('GENERATE_QUOTE');
export const LOADING = actionType('LOADING');
export const ADD_CONTRACTOR = actionType('ADD_CONTRACTOR')
export const ADD_INSURED = actionType('ADD_INSURED')
export const ADD_LEGAL_REPRESENTATIVE = actionType('ADD_LEGAL_REPRESENTATIVE')
export const ADD_INSURED_WORK_DATA = actionType('ADD_INSURED_WORK_DATA');
export const ADD_CONTRACTOR_WORK_DATA = actionType('ADD_CONTRACTOR_WORK_DATA');
export const ADD_ACCUMULATED = actionType('ADD_ACCUMULATED');
export const ADD_SUPPORT = actionType('ADD_SUPPORT');

//RESET
export const resetRedux = actionCreator(RESET,'reset') 
export const addClient = actionCreator(ADD_CLIENT,'client')
export const apiCliente = actionCreator(API_CLIENTE,'apiCliente')
export const updateClient = actionCreator(UPDATE_CLIENT,'otherDataClient')
export const addBeneficiary = actionCreator(ADD_BENEFICIARY,'beneficiary')
export const removeBeneficiary = actionCreator(REMOVE_BENEFICIARY,'idBeneficiary')
export const addWorkData = actionCreator(ADD_WORK_DATA,'workData')
export const updateWorkData = actionCreator(UPDATE_WORK_DATA,'otherWorkData')
export const addHealthStatement = actionCreator(ADD_HEALTH_STATEMENT, 'healthStatement')
export const addAnswers = actionCreator(ADD_ANSWERS, 'answers')
export const openModal = actionCreator(OPEN_MODAL, 'openModal'); 
export const modalSteps = actionCreator(MODAL_STEPS, 'modalSteps');
export const modalError = actionCreator(MODAL_ERRORS, 'modalError');
export const modalAside = actionCreator(MODAL_ASIDE, 'modalAside');
export const errortext = actionCreator(ERROR_TEXT, 'errortext'); //ERROR_TEXT
export const alert = actionCreator(ALERT, 'alert');
export const stateAlert = actionCreator(STATEALERT, 'stateAlert');
export const stepPosition = actionCreator(STEP_POSITION, 'stepPosition'); 
export const dataModal = actionCreator(DATA_MODAL, 'dataModal');
export const generateQuote = actionCreator(GENERATE_QUOTE, 'generateQuote');
export const loading = actionCreator(LOADING, 'loading');
export const addContractor = actionCreator(ADD_CONTRACTOR,'contractor')
export const addInsured = actionCreator(ADD_INSURED,'insured')
export const addLegalRepresentative = actionCreator(ADD_LEGAL_REPRESENTATIVE,'legal_representative')
export const addInsuredWorkData = actionCreator(ADD_INSURED_WORK_DATA,'insuredWorkData')
export const addContractorWorkData = actionCreator(ADD_CONTRACTOR_WORK_DATA,'contractorWorkData')
export const addAcumulated = actionCreator(ADD_ACCUMULATED, 'accumulated');
export const addSupport = actionCreator(ADD_SUPPORT, 'support');

export const createClientSAS = async (request, dispatch) => {
  dispatch(loading(true));

  const response = await API.post("api-rentas", "/create-client", request);
  if (response.status) {
      dispatch(generateQuote(true));
  }else{
    dispatch(openModal(true));
    dispatch(dataModal({
          success: false,
          message: "Ocurrió un error al intentar crear el cliente en SAS",
          btnText: "Cerrar",
          errorCreate : true
        }));
  }
  dispatch(loading(false));
};

export const updateClientSAS = async (request, dispatch) => {
  dispatch(loading(true));

 const response = await API.post("api-rentas", "/update-client", request);
  if (response.status) {
    dispatch(generateQuote(true));
  }
  else {
    dispatch(openModal(true));
    dispatch(dataModal({
      success: false,
      message: "No se actualizo el cliente en SAS, ¿Desea continuar?",
      btnText: null,
      errorUpdate : true
    }));
  }
 
  

  dispatch(loading(false));
};
